import BaseApi from '@/services/base.api.js';

class CommonApi extends BaseApi {
  async getSchedules(data) {
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/schedule/getschedule`,
      data
    });
  }

  async exportSchedule(data) {
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/schedule/exportschedule`,
      responseType: 'blob',
      data
    });
  }

  async getProfile() {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/account`
    });
  }

  async editProfile(data) {
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/account/edit`,
      data
    });
  }

  async getRegions() {
    let client = await this.getClientWithoutToken();
    return client({
      method: 'GET',
      url: process.env.VUE_APP_STORAGE_URL + 'mywires-regions.json'
    });
  }

  async uploadProfileImage(imageData) {
    let client = await this.getClient();
    let formData = new FormData();
    formData.append('ImageData', imageData);

    return client({
      method: 'POST',
      data: formData,
      url: `${this.basicFunctionUrl}api/profileImage`
    });
  }

  async getNews() {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/common/news`
    });
  }

  async getOneNews(newsId) {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/common/news/${newsId}`
    });
  }

  async getRecommendations(data) {
    let { oemName, machineType, specificationGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/recommendations?oemName=${oemName}&machineType=${machineType}&specificationGuid=${specificationGuid}`
    });
  }

  async getMachineTypesForUnitBySpecification(data) {
    let { specificationGuid } = data;
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/recommendations/getmachinetypesforunitbyspecification?specificationGuid=${specificationGuid}`
    });
  }

  async addCustomRecommendation(data) {
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/recommendations/custom`,
      data
    });
  }

  async acceptTos(version) {
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/account/edit/accepttos/${version}`
    });
  }

  async getWireOems() {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/common/oem/getwireoems`
    });
  }

  async setOemFilter(data) {
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/account/setoemfilter`,
      data
    });
  }

  async getLogData(data) {
    let client = await this.getClient();
    return client({
      method: 'POST',
      url: `${this.basicUrl}api/log/getlogs`,
      data
    });
  }

  async getLogFilterData() {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/log/getfilterdata`
    });
  }

  async getNotificationSettings() {
    let client = await this.getClient();
    return client({
      method: 'GET',
      url: `${this.basicUrl}api/unit/notification/settings/v2`
    });
  }

  async updateNotificationSetting(data) {
    let client = await this.getClient();
    return client({
      method: 'PUT',
      url: `${this.basicUrl}api/unit/${data.urlGuid}/setusernotificationsettings/v2`,
      data
    });
  }
}

export default CommonApi;
